// extracted by mini-css-extract-plugin
module.exports = {"poblacionContainer":"poblacionCustomField_poblacionContainer__17fNr","zipCode":"poblacionCustomField_zipCode__3Okb6","city":"poblacionCustomField_city__8qPcV"};